import axios from 'axios';

import { apiUrl, config } from '../Shared/config';


export const get = async (params) => {
  try {
    const { data } = await axios.get(apiUrl + `admin/${params.type}`, config);
    // console.log("9 - get=", params, data);
    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'load'; }
};


export const create = async (params) => {
  // console.log("17 - create=", params, config, params[params.type]);
  try {
    const { data } = await axios.post(apiUrl + `admin/${params.type}`, params[params.type], config);
    // console.log("20 - data=", data);
    return data.success ? data : data?.error;

  } catch (error) {
    console.log("23 - error=", error, error.response);
    return error.response?.data?.error || 'create';
  }
};


export const update = async (params) => {
  try {
    const { data } = await axios.put(apiUrl + `admin/${params.type}`, params[params.type], config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'update'; }
};


export const remove = async (params) => {
  try { // add database parameter when deleting a location
    const { data } = await axios.delete(apiUrl + `admin/${params.type}/${params.id}`, config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'delete'; }
};


export const logInAs = async (userId) => {
  try {
    const { data } = await axios.post(apiUrl + `admin/loginas`, { userId }, config);
    return data.success ? data : data?.error;
  }
  catch (error) {
    console.log("79 - error=", error);
    return error.response?.data?.error || 'loginas';
  }
};


export const getReports = async () => {
  try {
    const { data } = await axios.get(apiUrl + 'admin/report', config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }
};


export const getTemplates = async () => {
  try {
    const { data } = await axios.post(apiUrl + 'admin/template', {
    }, config);

    return data.success ? data : data?.error;

  } catch (error) {
    console.log("error=", error);
    return error.response?.data?.error || 'error';
  }
};


export const uploadTemplate = async (fileData /*filename, template*/) => {

  // console.log("74 - filename=", filename);
  try {    
    const { data } = await axios.post(apiUrl + `admin/uploadTemplate`, {fileData /*, filename, template*/}, config);
    return data.success ? data : data?.error;
  }
  catch (error) {
    console.log("79 - error=", error);
    return error.response?.data?.error || 'update';
  }
};

export const downloadTemplate = async (template) => {

  // console.log("87 - template=", template);
  try {    
    const { data } = await axios.post(apiUrl + `admin/downloadTemplate`, {template}, config);
    return data.success ? data : data?.error;
  }
  catch (error) {
    console.log("79 - error=", error);
    return error.response?.data?.error || 'update';
  }
};


export const getCustomSizes = async () => {
  try {
    const { data } = await axios.post(apiUrl + 'admin/customSizes', {
    }, config);

    return data.success ? data : data?.error;

  } catch (error) {
    console.log("error=", error);
    return error.response?.data?.error || 'error';
  }
};

export const getLocationGetVersions = async () => {
  try {
    const { data } = await axios.post(apiUrl + 'admin/locationGetVersions', 
    { getVersions: true}, config);

    return data.success ? data : data?.error;

  } catch (error) {
    console.log("error=", error);
    return error.response?.data?.error || 'error';
  }
};

export const updateViews = async () => {
  try {
    const { data } = await axios.post(apiUrl + 'admin/locationUpdateViews', 
    { getVersions: true}, config);

    return data.success ? data : data?.error;

  } catch (error) {
    console.log("error=", error);
    return error.response?.data?.error || 'error';
  }
};

export const checkPiceasoftInfo = async (params) => {
  try {
    const { data } = await axios.post(apiUrl + 'admin/checkPiceasoftInfo',
      params, config);

      // console.log("157 - data=", data);
      
    return data.success ? data : data?.error;

  } catch (error) {
    console.log("error=", error);
    return error.response?.data?.error || 'error';
  }
};

export const getLocationStatistics = async (params) => {

  // console.log("169 - params=", params);
  try {
    const { data } = await axios.post(apiUrl + 'admin/locationGetStatistics',
      params, config);

    return data.success ? data : data?.error;

  } catch (error) {
    console.log("error=", error);
    return error.response?.data?.error || 'error';
  }
};

export const reImportPiceasoftData = async (params) => {

  // console.log("184 - params=", params);
  try {
    const { data } = await axios.post(apiUrl + 'admin/reImportPiceasoftData',
      params, config);

    return data.success ? data : data?.error;

  } catch (error) {
    console.log("error=", error);
    return error.response?.data?.error || 'error';
  }
};



export const generateLicense = async (params) => {
  try {
    const { data } = await axios.post(apiUrl + 'admin/generateLicense',
      params, config);

    return data.success ? data : data?.error;

  } catch (error) {
    console.log("error=", error);
    return error.response?.data?.error || 'error';
  }
};


